import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=c88a97a4&scoped=true&"
import script from "./Dots.vue?vue&type=script&lang=js&"
export * from "./Dots.vue?vue&type=script&lang=js&"
import style0 from "./Dots.vue?vue&type=style&index=0&id=c88a97a4&lang=css&scoped=true&"
import style1 from "./Dots.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88a97a4",
  null
  
)

export default component.exports